import { mergeToken } from 'antd/es/theme/internal';
import genDropdownStyle from './dropdown.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var antPrefixCls = '.ant-select';

// ============================== Status ==============================
var genStatusStyle = function genStatusStyle(rootSelectCls, token, overwriteDefaultBorder) {
  var _ref, _ref2, _extends2, _rootSelectCls, _ref3;
  if (overwriteDefaultBorder === void 0) {
    overwriteDefaultBorder = false;
  }
  var borderHoverColor = token.borderHoverColor,
    hoverColor = token.hoverColor,
    antCls = token.antCls,
    activeBorderColor = token.activeBorderColor,
    activeColor = token.activeColor;
  var overwriteStyle = overwriteDefaultBorder ? (_ref = {}, _ref[antPrefixCls + "-selector"] = {
    borderColor: borderHoverColor
  }, _ref) : {};
  return _ref3 = {}, _ref3[rootSelectCls] = (_rootSelectCls = {}, _rootSelectCls["&:not(" + antPrefixCls + "-disabled):not(" + antPrefixCls + "-customize-input):not(" + antCls + "-pagination-size-changer)"] = _extends({}, overwriteStyle, (_extends2 = {}, _extends2["&:not(" + antPrefixCls + "-status-error)"] = (_ref2 = {}, _ref2["&:hover " + antPrefixCls + "-selector"] = {
    color: hoverColor
  }, _ref2), _extends2[antPrefixCls + "-focused& " + antPrefixCls + "-selector"] = {
    borderColor: activeBorderColor,
    boxShadow: "none",
    outline: 0,
    color: activeColor
  }, _extends2)), _rootSelectCls), _ref3;
};

// ============================== Styles ==============================
var genSelectStyle = function genSelectStyle(token) {
  var _antPrefixCls, _ref4;
  return [(_ref4 = {}, _ref4[antPrefixCls] = (_antPrefixCls = {
    // '.ant-select-arrow': {
    //   fontSize: 14,
    // },
    // '.ant-select-clear': {
    //   fontSize: 14,
    // },
    '&:hover .ant-select-arrow': {
      color: token.colorTextSecondary
    },
    '&.ant-select-focused .ant-select-arrow': {
      color: token.colorText
    },
    '&.ant-select-disabled .ant-select-arrow': {
      color: token.colorFill
    }
  }, _antPrefixCls["&-borderless " + antPrefixCls + "-selector"] = {
    backgroundColor: "transparent !important",
    borderColor: "transparent !important",
    boxShadow: "none !important"
  }, _antPrefixCls["&" + antPrefixCls + "-in-form-item"] = {
    width: '100%'
  }, _antPrefixCls), _ref4['.ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input)'] = {
    '.ant-select-selector': {
      borderColor: token.colorTextDisabled,
      color: token.colorTextQuaternary
    }
  }, _ref4),
  // ==                     Status                      ==
  genStatusStyle(antPrefixCls, mergeToken(token, {
    borderHoverColor: token.inputHoverBorderColor,
    hoverColor: token.inputHoverColor,
    outlineColor: token.inputHoverBorderColor,
    activeBorderColor: token.inputActiveBorderColor,
    activeColor: token.inputActiveColor
  })), genStatusStyle(antPrefixCls + "-status-error", mergeToken(token, {
    borderHoverColor: token.colorErrorHover,
    hoverColor: token.colorText,
    outlineColor: token.colorErrorOutline,
    activeBorderColor: token.colorErrorHover,
    activeColor: token.colorText
  }), true), genStatusStyle(antPrefixCls + "-status-warning", mergeToken(token, {
    borderHoverColor: token.colorWarningHover,
    hoverColor: token.colorText,
    outlineColor: token.colorWarningOutline,
    activeBorderColor: token.colorWarningHover,
    activeColor: token.colorText
  }), true)];
};
function genStyle(token) {
  return [{
    // x叉叉距离右侧8px
    '.ant-select-outlined.ant-select-multiple .ant-select-selection-item': {
      'padding-inline-end': '8px !important'
    },
    //间距
    '.ant-select-multiple .ant-select-selector': {
      paddingInlineStart: '4px !important',
      'padding-block': '2px !important'
    },
    '.ant-select-multiple .ant-select-selection-overflow-item-rest .ant-select-selection-item': {
      background: 'none'
    }
  }];
}

// ============================== Export ==============================
var selectStyleFn = function selectStyleFn(token) {
  var selectToken = mergeToken(token, {
    inputPaddingHorizontalBase: token.paddingSM - 1,
    selectDropdownPadding: token.paddingXXS
  });
  return [genStyle(), genDropdownStyle(selectToken), genSelectStyle(selectToken)];
};

export { antPrefixCls, selectStyleFn };
